import {
  LANDING_PAGE_ADD_REQUEST,
  LANDING_PAGE_ADD_REQUEST_SUCCESS,
  LANDING_PAGE_ADD_REQUEST_FAILURE,
  LANDING_PAGE_FETCH_REQUEST,
  LANDING_PAGE_FETCH_REQUEST_SUCCESS,
  LANDING_PAGE_FETCH_REQUEST_FAILURE,
  LANDING_PAGE_UPDATE_REQUEST,
  LANDING_PAGE_UPDATE_REQUEST_SUCCESS,
  LANDING_PAGE_UPDATE_REQUEST_FAILURE,
  LANDING_PAGE_CLEAN_REQUEST,
} from './actionTypes';

export const landingPageFetchRequest = () => {
  return {
    type: LANDING_PAGE_FETCH_REQUEST,
  };
};

export const landingPageFetchRequestSuccess = (data) => {
  return {
    type: LANDING_PAGE_FETCH_REQUEST_SUCCESS,
    data,
  };
};

export const landingPageFetchRequestFailure = (error) => {
  return {
    type: LANDING_PAGE_FETCH_REQUEST_FAILURE,
    error,
  };
};

export const landingPageAddRequest = () => {
  return {
    type: LANDING_PAGE_ADD_REQUEST,
  };
};

export const landingPageAddRequestSuccess = (data) => {
  return {
    type: LANDING_PAGE_ADD_REQUEST_SUCCESS,
    data,
  };
};

export const landingPageAddRequestFailure = (error) => {
  return {
    type: LANDING_PAGE_ADD_REQUEST_FAILURE,
    error,
  };
};

export const landingPageUpdateRequest = () => {
  return {
    type: LANDING_PAGE_UPDATE_REQUEST,
  };
};

export const landingPageUpdateRequestSuccess = (data) => {
  return {
    type: LANDING_PAGE_UPDATE_REQUEST_SUCCESS,
    data,
  };
};

export const landingPageUpdateRequestFailure = (error) => {
  return {
    type: LANDING_PAGE_UPDATE_REQUEST_FAILURE,
    error,
  };
};

export const landingPageCleanRequest = () => {
  return {
    type: LANDING_PAGE_CLEAN_REQUEST,
  };
};
